import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ClusterService } from '@fry/lib/organisations/cluster.service';

import { TranslationFormStore } from './translation-form.store';


@Component({
    selector: 'eas-translation-form',
    templateUrl: './translation-form.component.html',
    styleUrls: ['./translation-form.component.css'],
    standalone: false
})
export class TranslationFormComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  config: any;
  form: FormArray;
  originalLanguage: { languageCode: string, languageName: string };
  translationLanguage: { languageCode: string, languageName: string };

  constructor(
    private route: ActivatedRoute,
    private cluster: ClusterService,
    private translationFormStore: TranslationFormStore
  ) {

  }

  ngOnInit() {
    const organisationLanguages = this.cluster.getCurrentOrganisation().availableLanguages;
    const originalOrganisationLanguage = organisationLanguages === null
      ? undefined
      : organisationLanguages.find(
        organisationLanguage => organisationLanguage['is_default'] === true
      );

    if (originalOrganisationLanguage !== undefined) {
      this.originalLanguage = {
        languageCode: originalOrganisationLanguage['language_code'],
        languageName: originalOrganisationLanguage['language_name']
      }
    }

    this.route.params.subscribe(params => {
      const translationLanguageCode = params.languageCode;

      const translationOrganisationLanguage = organisationLanguages === null
        ? undefined
        : organisationLanguages.find(
          organisationLanguage => organisationLanguage['language_code'] === translationLanguageCode
        );

      if (translationOrganisationLanguage !== undefined) {
        this.translationLanguage = {
          languageCode: translationOrganisationLanguage['language_code'],
          languageName: translationOrganisationLanguage['language_name']
        }
      }

      this.translationFormStore.initialize(params.docType, params.objectId, params.languageCode);
    });

    this.translationFormStore.translationConfig$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        config => {
          this.config = config;
        }
      );

    this.translationFormStore.translationForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        form => {
          this.form = form;
        }
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getSectionForm(sectionIndex): FormGroup {
    return this.form.at(sectionIndex) as FormGroup;
  }

  onSave() {
    this.translationFormStore.save();
  }
}
